import React from "react";

interface ArticleCardProps {
  image: string;
  title: string;
  link?: string;
  className?: string;
}

const ArticleCard: React.FC<ArticleCardProps> = ({
  image,
  title,
  link = "#",
  className = "",
}) => {
  return (
    <div
      className={`bg-card rounded-[24px] overflow-hidden shadow-sm
      h-[320px] xs:h-[340px] sm:h-[360px] md:h-[380px]
      transition-all duration-300 ${className}`}
    >
      <img
        src={image}
        alt={title}
        className="w-full h-[55%] object-cover transition-transform duration-300 group-hover:scale-105"
      />
      <div className="p-4 sm:p-6 flex flex-col justify-between h-[45%]">
        <h3
          className="text-heading font-sora font-semibold 
          text-sm sm:text-base leading-snug"
        >
          {title}
        </h3>
        <a
          href={link}
          className="bg-gradient-to-b from-[#0B2F9F] to-[#3F6AEF] 
            text-white font-sans text-sm px-5 py-2 rounded-full 
            w-fit shadow-sm hover:shadow-md transition-all duration-300"
        >
          Read More
        </a>
      </div>
    </div>
  );
};

export default ArticleCard;
